import { cloneDeep, set } from 'lodash-es';

import {
  useGetStateByStateKey,
  usePutState,
} from '../../../api/lending/lapiHooks';

const hasTurnoverExpired = ({
  turnoverLastUpdated,
  dateJoined,
}: {
  turnoverLastUpdated: number;
  dateJoined: number;
}) => {
  const sixMonths = 6 * 30 * 24 * 60 * 60 * 1000;

  // If your turnover was updated in the last 6 months, don't refresh
  if (turnoverLastUpdated && turnoverLastUpdated > Date.now() - sixMonths) {
    return false;
  }

  // We can't rely on the turnover update datetime (as we historically didn't store it in iwocapay),
  // so if it doesn't exist check if the user signed up in the last 6 months instead
  if (!turnoverLastUpdated && dateJoined > Date.now() - sixMonths) {
    return false;
  }

  // Otherwise ask for a refresh
  return true;
};

export const useUpdateTurnover = () => {
  const { state } = useGetStateByStateKey();
  const { putState, isPending } = usePutState();

  const turnoverLastUpdated = Date.parse(
    state?.application?.company?.last_12_months_turnover?.datetime || '',
  );

  const updateTurnover = async (turnover: number) => {
    if (!state) return;
    const newState = cloneDeep(state);
    set(newState, 'application.company.last_12_months_turnover', {
      amount: parseInt(String(turnover)),
      datetime: new Date().toISOString(),
    });
    await putState({ data: newState });
  };

  const isTurnoverExpired = hasTurnoverExpired({
    turnoverLastUpdated,
    dateJoined: 0,
  });

  return {
    updateTurnover,
    isTurnoverExpired,
    loadingTurnover: isPending,
  };
};
